const menuDinners = [
  {
    id: 1,
    name: "Noor Trio",
    description: [
      "One skewer each of Beef Kebab, Chicken Kebab and Lule Kebab.",
      "Choice of French Fries or Rice.",
      "Served with side of Hummus, Tahini Sauce, Garlic Sauce or Baba Dip.",
      "Served with salad & pita bread.",
      "Substitute salad for Fattoush ($1.00) or Tabbouli ($2.00)",
    ],
    price: "$24.93",
  },
  {
    id: 2,
    name: "Beef Kebab",
    description: [
      "Two skewers of flame-broiled marinated Angus beef, mushrooms & onions.",
      "Choice of French Fries or Rice.",
      "Served with side of Hummus, Tahini Sauce, Garlic Sauce or Baba Dip.",
      "Served with salad & pita bread.",
      "Substitute salad for Fattoush ($1.00) or Tabbouli ($2.00)",
    ],
    price: "$24.41",
  },
  {
    id: 3,
    name: "Beef Shawerma",
    description: [
      "Tender marinated Angus beef, slow-cooked on a vertical rotisserie.",
      "Choice of French Fries or Rice.",
      "Served with side of Hummus, Tahini Sauce, Garlic Sauce or Baba Dip.",
      "Served with salad & pita bread.",
      "Substitute salad for Fattoush ($1.00) or Tabbouli ($2.00)",
    ],
    price: "$20.77",
  },
  {
    id: 4,
    name: "Lule Kebab",
    description: [
      "Three skewers of flame-broiled marinated Angus ground beef.",
      "Choice of French Fries or Rice.",
      "Served with side of Hummus, Tahini Sauce, Garlic Sauce or Baba Dip.",
      "Served with salad & pita bread.",
      "Substitute salad for Fattoush ($1.00) or Tabbouli ($2.00)",
    ],
    price: "$20.77",
  },
  {
    id: 5,
    name: "Chicken Kebab",
    description: [
      "Two skewers of flame-broiled marinated chicken breast.",
      "Choice of French Fries or Rice.",
      "Served with side of Hummus, Tahini Sauce, Garlic Sauce or Baba Dip.",
      "Served with salad & pita bread.",
      "Substitute salad for Fattoush ($1.00) or Tabbouli ($2.00)",
    ],
    price: "$23.37",
  },
  {
    id: 6,
    name: "Chicken Shawerma",
    description: [
      "Tender marinated chicken, slow-cooked on a vertical rotisserie.",
      "Choice of French Fries or Rice.",
      "Served with side of Hummus, Tahini Sauce, Garlic Sauce or Baba Dip.",
      "Served with salad & pita bread.",
      "Substitute salad for Fattoush ($1.00) or Tabbouli ($2.00)",
    ],
    price: "$20.77",
  },
  {
    id: 7,
    name: "Falafel Plate",
    description: [
      "Ground chickpeas and fava beans, seasoned and fried to a crispy golden brown.",
      "Choice of French Fries or Rice.",
      "Served with side of Hummus, Tahini Sauce, Garlic Sauce or Baba Dip.",
      "Served with salad & pita bread.",
      "Substitute salad for Fattoush ($1.00) or Tabbouli ($2.00)",
    ],
    price: "$16.09",
  },
  {
    id: 8,
    name: "Veggie Lovers Plate",
    description: [
      "Tabbouli, fattoush, hummus & choice of baba dip or sarma (3pc) on a garden salad",
    ],
    price: "$16.61",
  },
  {
    id: 9,
    name: "Protein Bowl",
    description: [
      "Bowl of Rice Pilaf with a choice of Chickeen Shawerma or Beef Shawerma",
    ],
    price: "$15.57",
  },
];

export default menuDinners;
